var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSplitViewBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 22H11V17.5H3L2.7959 17.4893C1.78722 17.387 1 16.5357 1 15.5V7.5C1 6.39543 1.89543 5.5 3 5.5H11V2H13V22ZM3 14.2041V15.5H11V13.6768L9.5166 14.2705L8.50098 12.2393L3 14.2041ZM3 12.0811L4.33301 11.6045C4.12286 11.288 4 10.9084 4 10.5C4 9.39543 4.89543 8.5 6 8.5C7.03664 8.5 7.88834 9.28876 7.98926 10.2988L8.66406 10.0586L9.49805 9.75977L10.4824 11.7295L11 11.5225V7.5H3V12.0811Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 7.5C22.1046 7.5 23 8.39543 23 9.5V17.5C23 18.6046 22.1046 19.5 21 19.5H14V7.5H21ZM16 15.373V17.5H20.3564L18.5635 14.2734L16 15.373ZM16 13.1973L19.4355 11.7256L21 14.541V9.5H16V13.1973Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitViewBlack);
export default __webpack_public_path__ + "static/media/Split_ViewBlack.5c3b9d28964870cda34a8c902fd88278.svg";
export { ForwardRef as ReactComponent };